import { Controller } from '@hotwired/stimulus';
import { useIntersection, useResizeObserver } from 'stimulus-library/dist';

export default class extends Controller {
  static targets = [
    'slide',
    'track',
    'controls',
    'slideName',
  ];

  static values = {
    activeSlide: {
      type: Number,
      default: 0,
    },
  };

  connect() {
    const self = this;
    this.checkShouldRenderControls();
    useResizeObserver(this, this.trackTarget, self.checkShouldRenderControls, {});
    useIntersection(this, this.element, self.appear, self.disappear);
  }

  appear() {
    this._isVisible = true;
    this.scrollActiveSlideIntoView();
  }

  disappear() {
    this._isVisible = false;
  }

  get isVisible() {
    return this._isVisible || false;
  }

  get rightmostSlideOutOfView() {
    const track = this.trackTarget;
    const trackBounds = track.getBoundingClientRect();

    let rightmostIndex = 0;
    if (
      Array.from(this.slideTargets).some((slide, index) => {
        const slideBounds = slide.getBoundingClientRect();
        if (slideBounds.right > trackBounds.right) {
          rightmostIndex = index;
          return true;
        }
        return false;
      })
    ) {
      return rightmostIndex;
    }
    return this.slideTargets.length - 1;
  }

  get leftmostVisibleSlideIndex() {
    const track = this.trackTarget;
    const trackBounds = track.getBoundingClientRect();

    const slideCount = this.slideTargets.length - 1;
    let leftmostIndex = 0;
    if (
      Array.from(this.slideTargets).reverse().some((slide, index) => {
        const slideBounds = slide.getBoundingClientRect();
        if (slideBounds.left < trackBounds.left) {
          leftmostIndex = slideCount - index;
          return true;
        }
        return false;
      })
    ) {
      return leftmostIndex;
    }
    return 0;
  }

  checkShouldRenderControls() {
    const should = this.trackTarget.scrollWidth > this.trackTarget.clientWidth;
    if (should) {
      this.element.classList.add('has-overflow');
      this.controlsTarget.classList.remove('hidden');
    } else {
      this.element.classList.remove('has-overflow');
      this.controlsTarget.classList.add('hidden');
    }
  }

  scrollActiveSlideIntoView() {
    requestAnimationFrame(() => {
      const slide = this.slideTargets[this.activeSlideValue];
      slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      if (this.hasSlideNameTarget && slide.dataset.slideName) {
        this.slideNameTarget.classList.remove('hidden');
        this.slideNameTarget.innerHTML = slide.dataset.slideName;
      } else {
        this.slideNameTarget.classList.add('hidden');
      }
    });
  }

  activeSlideValueChanged() {
    if (!this.isVisible) {
      return;
    }
    this.scrollActiveSlideIntoView();
  }

  right() {
    this.activeSlideValue = this.rightmostSlideOutOfView;
  }

  left() {
    this.activeSlideValue = this.leftmostVisibleSlideIndex;
  }
}
